<template>
  <footer>
    <div class="socialmedia">
      <a href="http://www.instagram.com/johnnyyungy" target="_blank">
        <img src="@/assets/images/instagram.png" width="35" height="35" alt="Instagram">
      </a>
      <a href="https://twitter.com/johnnyyungy" target="_blank">
        <img src="@/assets/images/twitter.png" width="35" height="35" alt="Twitter">
      </a>
      <a href="https://www.youtube.com/channel/UCZhsbHXGqVWHivekOiC9ofQ" target="_blank">
        <img src="@/assets/images/youtube.png" width="35" height="35" alt="YouTube">
      </a>
      <a href="https://www.facebook.com/johnnyyungy" target="_blank">
        <img src="@/assets/images/facebook.png" width="35" height="35" alt="Facebook">
      </a>
      <a href="https://linkedin.com/in/john-yung-53930945" target="_blank">
        <img src="@/assets/images/linkedin.png" width="35" height="35" alt="LinkedIn">
      </a>
    </div>
    <div class="copyright">All work © John Yung 2019 - 2026 - All Rights Reserved</div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>
